module.exports = __webpack_public_path__ + "components/flag/static/square/hk-9b3a38e7b5e0338a071c0ba296149dc5.svg";